import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Store } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { NumField } from "../../components/mshop/ui";
import { toMilli } from "../../lib/mshopCalc";

export default function MShopSetup() {
    const navigate = useNavigate();
    const { company, refresh } = useAuth();
    const [gold, setGold] = useState("");
    const [cash, setCash] = useState("");
    const [bank, setBank] = useState("");
    const [busy, setBusy] = useState(false);
    const valid = [gold, cash, bank].every((x) => toMilli(x) !== null);
    const save = async () => {
        setBusy(true);
        try {
            await api.post("/mshop/opening", { gold, cash, bank });
            toast.success("تم حفظ الرصيد الابتدائي");
            await refresh();
            navigate("/", { replace: true });
        } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
        finally { setBusy(false); }
    };
    return (
        <div className="flex min-h-screen items-center justify-center bg-[#F4F3EF] px-4 py-10" dir="rtl" data-testid="mshop-setup-page">
            <div className="w-full max-w-md rounded-[28px] border border-[#E7E5DF] bg-white p-6 shadow-sm sm:p-8">
                <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F6E7C1] text-[#8A6A1F]"><Store className="h-7 w-7" /></span>
                <h1 className="mt-4 font-heading text-2xl font-black text-neutral-900">إعداد محل الموظف</h1>
                <p className="mt-1 text-sm text-neutral-500">{company?.company_name} — أدخل وزن الكسر الموجود والكاش والبنك قبل بدء التسجيل.</p>
                <div className="mt-6 space-y-5">
                    <NumField big label="وزن الكسر الموجود" unit="جرام" value={gold} onChange={setGold} testId="mshop-setup-gold-input" />
                    <NumField big label="الكاش الافتتاحي" unit="ر.ع" value={cash} onChange={setCash} testId="mshop-setup-cash-input" />
                    <NumField big label="البنك الافتتاحي" unit="ر.ع" value={bank} onChange={setBank} testId="mshop-setup-bank-input" />
                </div>
                <button onClick={save} disabled={busy || !valid} className="mt-6 h-14 w-full rounded-2xl bg-[#1F1D1A] font-bold text-[#F3DFA2] hover:bg-black disabled:bg-[#A3A19D]" data-testid="mshop-setup-save-btn">{busy ? "جارٍ الحفظ..." : "حفظ ومتابعة"}</button>
            </div>
        </div>
    );
}
